import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { useGetTaskQuery, useMarkAsViewedQuery } from '../../../../entities/tasks/model/api/taskApi';
import { Header } from '../../../../shared/ui/Header';
import { Task } from '../../../../widgets/tasks/ui/Task';

export const TaskPage = () => {
  const { taskId } = useParams();
  const location = useLocation();

  const { data, isSuccess } = useGetTaskQuery(taskId!);
  useMarkAsViewedQuery(taskId!, { skip: !isSuccess });

  return (
    <>
      <Header goBackLink={location.state?.goBackTask}>{data?.bodyField.task_statusField.itemField}</Header>
      <Task />
    </>
  );
};
